import mod from "-!./rank.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./rank.js?vue&type=script&lang=js&external"